export default __webpack_public_path__ + "static/og-image-af35a3542bbee17b215b87a9daad14d2.png";